import AutoBetItem from './AutoBetItem';
export default AutoBetItem;